import { useEffect, useState } from 'react'
import Layout from './Layout'
import api from '../services/api'

const STATUS = {
  pendente:  { label:'Aguardando aprovação', bg:'#fef9c3', cor:'#854d0e', icone:'⏳' },
  ativo:     { label:'Aprovado',             bg:'#EAF3DE', cor:'#3B6D11', icone:'✅' },
  rejeitado: { label:'Rejeitado',            bg:'#FCEBEB', cor:'#791F1F', icone:'❌' },
}

export default function Cidadaos() {
  const [lista, setLista] = useState([])
  const [filtro, setFiltro] = useState('pendente')
  const [tipoPessoa, setTipoPessoa] = useState('todos') // todos | PF | PJ
  const [busca, setBusca] = useState('')
  const [modalRejeitar, setModalRejeitar] = useState(null)
  const [motivo, setMotivo] = useState('')
  const [senhaGerada, setSenhaGerada] = useState(null)
  const [load, setLoad] = useState(false)
  const [sucesso, setSucesso] = useState('')
  const usuario = JSON.parse(localStorage.getItem('pg_usuario') || '{}')

  useEffect(() => { carregar() }, [])

  async function carregar() {
    try { const r = await api.get('/cidadaos'); setLista(r.data) } catch {}
  }

  async function aprovar(id) {
    setLoad(true)
    try {
      await api.post(`/cidadaos/${id}/aprovar`)
      setSucesso('Cidadão aprovado!'); carregar()
      setTimeout(() => setSucesso(''), 3000)
    } catch(e) { alert(e.response?.data?.erro || 'Erro ao aprovar') }
    finally { setLoad(false) }
  }

  async function rejeitar() {
    if (!motivo) { alert('Informe o motivo da rejeição'); return }
    setLoad(true)
    try {
      await api.post(`/cidadaos/${modalRejeitar}/rejeitar`, { motivo })
      setSucesso('Cadastro rejeitado.'); setModalRejeitar(null); setMotivo(''); carregar()
      setTimeout(() => setSucesso(''), 3000)
    } catch(e) { alert(e.response?.data?.erro || 'Erro') }
    finally { setLoad(false) }
  }

  async function toggleAtivo(c) {
    try {
      await api.put(`/cidadaos/${c.id}`, { status: c.status === 'ativo' ? 'rejeitado' : 'ativo' })
      carregar()
    } catch {}
  }

  async function resetarSenha(id) {
    if (!window.confirm('Gerar nova senha provisória para este cidadão?')) return
    try {
      const r = await api.post(`/cidadaos/${id}/resetar-senha`)
      setSenhaGerada(r.data)
    } catch(e) { alert(e.response?.data?.erro || 'Erro ao resetar senha') }
  }

  const pendentes = lista.filter(c => c.status === 'pendente').length
  const filtrado = lista.filter(c => {
    const matchStatus = filtro === 'todos' || c.status === filtro
    const matchTipo = tipoPessoa === 'todos' || (c.tipo_pessoa || 'PF') === tipoPessoa
    const matchBusca = !busca || c.nome.toLowerCase().includes(busca.toLowerCase()) || c.cpf_cnpj?.includes(busca) || c.email?.toLowerCase().includes(busca.toLowerCase())
    return matchStatus && matchTipo && matchBusca
  })

  const podeAprovar = usuario.perfil === 'admin' || usuario.pode_aprovar_cidadao

  return (
    <Layout>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div>
          <h1 style={{ fontSize:18, fontWeight:500, margin:'0 0 4px' }}>Cidadãos cadastrados</h1>
          {pendentes > 0 && (
            <div style={{ fontSize:13, color:'#854d0e', background:'#fef9c3', padding:'4px 10px', borderRadius:99, display:'inline-block' }}>
              ⏳ {pendentes} aguardando aprovação
            </div>
          )}
        </div>
      </div>

      {sucesso && <div style={{ background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:12, fontSize:13, color:'#15803d', marginBottom:16 }}>{sucesso}</div>}

      {/* MODAL SENHA GERADA */}
      {senhaGerada && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
          <div style={{ background:'white', borderRadius:12, padding:28, width:'100%', maxWidth:400, textAlign:'center' }}>
            <div style={{ fontSize:36, marginBottom:12 }}>🔑</div>
            <div style={{ fontSize:15, fontWeight:600, marginBottom:8 }}>Senha provisória gerada!</div>
            <div style={{ fontSize:13, color:'#6b7280', marginBottom:16 }}>Entregue esta senha ao cidadão. Ele deverá alterá-la no próximo acesso.</div>
            <div style={{ background:'#f0f7ff', border:'2px solid #185FA5', borderRadius:10, padding:'16px 20px', marginBottom:20 }}>
              <div style={{ fontSize:11, color:'#9ca3af', marginBottom:4 }}>Senha provisória</div>
              <div style={{ fontFamily:'monospace', fontSize:24, fontWeight:700, color:'#185FA5', letterSpacing:2 }}>{senhaGerada.senha_provisoria}</div>
            </div>
            <button onClick={() => { navigator.clipboard?.writeText(senhaGerada.senha_provisoria); setSucesso('Senha copiada!') }}
              style={{ width:'100%', padding:10, background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', marginBottom:8 }}>
              📋 Copiar senha
            </button>
            <button onClick={() => setSenhaGerada(null)}
              style={{ width:'100%', padding:10, border:'1px solid #d1d5db', borderRadius:8, fontSize:13, cursor:'pointer', background:'white' }}>
              Fechar
            </button>
          </div>
        </div>
      )}

      {/* MODAL REJEITAR */}
      {modalRejeitar && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
          <div style={{ background:'white', borderRadius:12, padding:24, width:'100%', maxWidth:420 }}>
            <div style={{ fontSize:15, fontWeight:500, marginBottom:14 }}>Rejeitar cadastro</div>
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Motivo da rejeição *</label>
              <textarea value={motivo} onChange={e=>setMotivo(e.target.value)} placeholder="Informe o motivo para o cidadão..."
                style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, minHeight:80, resize:'vertical', boxSizing:'border-box' }} />
            </div>
            <div style={{ display:'flex', gap:8 }}>
              <button onClick={rejeitar} disabled={load} style={{ flex:1, padding:10, background:'#A32D2D', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
                {load?'Rejeitando...':'Confirmar rejeição'}
              </button>
              <button onClick={() => { setModalRejeitar(null); setMotivo('') }} style={{ padding:'10px 16px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, cursor:'pointer', background:'white' }}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* FILTROS */}
      <div style={{ display:'flex', gap:8, marginBottom:12, flexWrap:'wrap', alignItems:'center' }}>
        {/* Tipo pessoa */}
        <div style={{ display:'flex', gap:4, background:'white', border:'1px solid #e5e7eb', borderRadius:99, padding:4 }}>
          {[['todos','Todos'],['PF','👤 PF'],['PJ','🏢 PJ']].map(([k,l])=>(
            <button key={k} onClick={()=>setTipoPessoa(k)} style={{ padding:'4px 12px', border:'none', borderRadius:99, fontSize:12, cursor:'pointer', background:tipoPessoa===k?'#185FA5':'transparent', color:tipoPessoa===k?'white':'#6b7280', fontWeight:tipoPessoa===k?500:400 }}>{l}</button>
          ))}
        </div>
        {/* Status */}
        {[['pendente','⏳ Pendentes'],['ativo','✅ Aprovados'],['rejeitado','❌ Rejeitados'],['todos','Todos']].map(([k,l]) => (
          <button key={k} onClick={() => setFiltro(k)} style={{
            padding:'6px 14px', border:`1.5px solid ${filtro===k?'#185FA5':'#e5e7eb'}`,
            borderRadius:99, fontSize:13, cursor:'pointer',
            background:filtro===k?'#E6F1FB':'white',
            color:filtro===k?'#185FA5':'#6b7280', fontWeight:filtro===k?500:400
          }}>
            {l} {k!=='todos'&&<span style={{ opacity:0.7 }}>({lista.filter(c=>c.status===k&&(tipoPessoa==='todos'||(c.tipo_pessoa||'PF')===tipoPessoa)).length})</span>}
          </button>
        ))}
        <input value={busca} onChange={e=>setBusca(e.target.value)} placeholder="Buscar por nome, CPF ou e-mail..."
          style={{ flex:1, minWidth:200, padding:'6px 12px', border:'1px solid #e5e7eb', borderRadius:99, fontSize:13 }} />
      </div>

      <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden' }}>
        {filtrado.length === 0
          ? <div style={{ padding:40, textAlign:'center', color:'#9ca3af', fontSize:14 }}>
              {filtro==='pendente' ? '✅ Nenhum cadastro pendente!' : 'Nenhum cidadão encontrado.'}
            </div>
          : filtrado.map((c,i) => {
            const st = STATUS[c.status] || STATUS.pendente
            const isPJ = (c.tipo_pessoa || 'PF') === 'PJ'
            return (
              <div key={c.id} style={{ padding:'14px 20px', borderBottom:i<filtrado.length-1?'1px solid #f3f4f6':'none' }}>
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <div style={{ width:38, height:38, borderRadius:'50%', background:isPJ?'#EAF3DE':'#E6F1FB', display:'flex', alignItems:'center', justifyContent:'center', fontSize:16, flexShrink:0 }}>
                    {isPJ ? '🏢' : '👤'}
                  </div>
                  <div style={{ flex:1 }}>
                    <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:2, flexWrap:'wrap' }}>
                      <div style={{ fontSize:13, fontWeight:500 }}>{c.nome}</div>
                      <span style={{ background:isPJ?'#EAF3DE':'#E6F1FB', color:isPJ?'#3B6D11':'#185FA5', fontSize:10, padding:'1px 7px', borderRadius:99 }}>
                        {isPJ ? '🏢 Empresa' : '👤 Pessoa Física'}
                      </span>
                      <span style={{ background:st.bg, color:st.cor, fontSize:10, padding:'1px 8px', borderRadius:99, fontWeight:500 }}>
                        {st.icone} {st.label}
                      </span>
                    </div>
                    {isPJ && c.razao_social && <div style={{ fontSize:12, color:'#374151', marginBottom:2 }}>{c.razao_social}</div>}
                    <div style={{ fontSize:12, color:'#9ca3af' }}>
                      {c.cpf_cnpj} · {c.email}
                      {c.telefone ? ` · ${c.telefone}` : ''}
                    </div>
                    <div style={{ fontSize:11, color:'#9ca3af', marginTop:2 }}>
                      Cadastrado em {new Date(c.criado_em).toLocaleDateString('pt-BR')}
                      {c.aprovado_em ? ` · Aprovado em ${new Date(c.aprovado_em).toLocaleDateString('pt-BR')}` : ''}
                      {c.motivo_rejeicao ? ` · Motivo: ${c.motivo_rejeicao}` : ''}
                      {c.ultimo_acesso ? ` · Último acesso: ${new Date(c.ultimo_acesso).toLocaleDateString('pt-BR')}` : ''}
                    </div>
                  </div>
                  {podeAprovar && (
                    <div style={{ display:'flex', gap:6, flexShrink:0, flexWrap:'wrap', justifyContent:'flex-end' }}>
                      {c.status === 'pendente' && <>
                        <button onClick={() => aprovar(c.id)} disabled={load} style={{ padding:'5px 12px', background:'#3B6D11', color:'white', border:'none', borderRadius:6, fontSize:12, cursor:'pointer', fontWeight:500 }}>
                          ✅ Aprovar
                        </button>
                        <button onClick={() => setModalRejeitar(c.id)} style={{ padding:'5px 12px', border:'1px solid #fecaca', borderRadius:6, fontSize:12, cursor:'pointer', background:'white', color:'#dc2626' }}>
                          ❌ Rejeitar
                        </button>
                      </>}
                      {c.status === 'ativo' && <>
                        <button onClick={() => resetarSenha(c.id)} style={{ padding:'5px 10px', border:'1px solid #B5D4F4', borderRadius:6, fontSize:12, cursor:'pointer', background:'white', color:'#185FA5' }}>
                          🔑 Resetar senha
                        </button>
                        <button onClick={() => toggleAtivo(c)} style={{ padding:'5px 10px', border:'1px solid #fecaca', borderRadius:6, fontSize:12, cursor:'pointer', background:'white', color:'#dc2626' }}>
                          Bloquear
                        </button>
                      </>}
                      {c.status === 'rejeitado' && (
                        <button onClick={() => toggleAtivo(c)} style={{ padding:'5px 10px', border:'1px solid #bbf7d0', borderRadius:6, fontSize:12, cursor:'pointer', background:'white', color:'#15803d' }}>
                          Reativar
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )
          })
        }
      </div>
    </Layout>
  )
}
